"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESourceActionType = void 0;
let ESourceActionType = exports.ESourceActionType = /*#__PURE__*/function (ESourceActionType) {
  ESourceActionType["Change"] = "source/change";
  return ESourceActionType;
}({});